import type { AbilityDef } from "../../sim";

/**
 * «Скачок»: ← → (назад, затем вперёд, без кнопки) — телепорт за спину сопернику. Одно деление Ярости, секрет до боя.
 * Джон 04.11.2026, 23:00: «Я бы сделал телепорт (назад-вперёд)» — вместо □ + △.
 */
export const BLINK: AbilityDef = {
  id: "blink",
  name: "Скачок",
  input: { gesture: ["B", "F"] },
  pose: "blink",
  // ~0,53 с (Джон 21:26: «чуть-чуть медленней… сжался в этот шар и там раскрылся»): 7 кадров замаха — с тела
  // сыплются чешуйки, можно закрыться; 20 кадров — рой сжимается в шар, шар огибает соперника сзади, раскрывается
  startup: 27,
  active: 0,
  recovery: 5,
  vanish: [7, 27],
  cost: 1000,
  secret: true,
  actions: [{ frame: 22, type: "teleport", params: { distance: 80 } }],
  fx: { start: "teleport/out" },
  sound: { start: "blink" },
};
